var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AgmInfoWindow } from '@agm/core';
import { ElementRef, OnInit, Inject, ComponentFactoryResolver, Injector, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from 'common/components/base.component';
import { EventLocationAdding } from '../event.add.location';
import { EventPageAdding } from '../event.add.page';
import { AddressInputComponent } from 'common/components/address.input/address.input.component';
import { HubVisitorFeatureToggle, } from 'models/hub/hub.visitor.feature.toggle';
import { HubApiService } from 'services/hub.api.service';
import { AlertifyService } from 'services/alertify.service';
import { HubComponent } from 'components/hub/hub.component';
import { ModalService } from 'common/services/modal.service';
import { ToggleAndDataSourceStore, HubFacebookPageFeedsStore, HubFacebookLocationFeedsStore, PDFSettingsStore, } from 'stores/hub.calendar.store';
import { HubFacebookFeedsCommand, AddFacebookGeneralFeedCommand, } from 'commands/hub/event/add.facebook.general.feed.command';
import { PullGooglePlaceTypeModalActions } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.provider';
import { localStorageKeys } from 'common/constants/local.storage.keys';
import { PullGooglePlaceTypeModalComponent } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component';
import { ConfirmModalData, ConfirmModalActions, } from 'common/components/confirm.modal/confirm.modal.provider';
import { AddEventBriteGeneralFeedCommand } from 'commands/hub/event/add.eventbrite.general.feed.command';
import { ConfirmModalComponent } from 'common/components/confirm.modal/confirm.modal.component';
import { constantTooltip } from 'common/constants/constant.tooltip';
import { ConfigService } from 'services/config.service';
import { AddFacebookLocationFeedCommand } from 'commands/hub/event/add.facebook.location.feed.command';
import { GeoService } from 'services/geo.service';
import { config } from '../../../../../config/config';
import { MatDialog } from '@angular/material/dialog';
import { InputModalComponent } from '../../../../common/components/input.modal/input.modal.component';
import { InputModalActions, InputModalData, } from '../../../../common/components/input.modal/input.modal.provider';
import { CropperSettings } from 'ngx-img-cropper';
import { PDFSettingCommand } from '../../export.pdf.modal/export.pdf.modal.provider';
import { ImageService } from '../../../../services/image.service';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { MatTabGroup } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ImageCropperWithPreviewComponent } from '../../../../common/components/image.cropper/image.cropper.component';
import { ShowInfoModalComponent } from '../../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions, } from '../../show.info.modal/show.info.modal.provider';
import { BulkAIDescriptionsStore } from '../../../../stores/hub.calendar.store';
import { BulkAIDescriptionsModalComponent } from '../../bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component';
import * as jwt_decode from 'jwt-decode';
var ContentManagementComponent = /** @class */ (function (_super) {
    __extends(ContentManagementComponent, _super);
    function ContentManagementComponent(router, formBuilder, hubApiService, activatedRoute, alertify, modalService, dialog, customizationService, imageService, parent, pdfSettingsStore, toggleAndDataSourceStore, hubFacebookFeedsStore, hubFacebookLocationFeedsStore, bulkAIDescriptionsStore, componentFactoryResolver, injector) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.formBuilder = formBuilder;
        _this.hubApiService = hubApiService;
        _this.activatedRoute = activatedRoute;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.dialog = dialog;
        _this.customizationService = customizationService;
        _this.imageService = imageService;
        _this.parent = parent;
        _this.pdfSettingsStore = pdfSettingsStore;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.hubFacebookFeedsStore = hubFacebookFeedsStore;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.bulkAIDescriptionsStore = bulkAIDescriptionsStore;
        _this.componentFactoryResolver = componentFactoryResolver;
        _this.injector = injector;
        _this.eventPage = new EventPageAdding();
        _this.placePageFacebook = new EventPageAdding();
        _this.eventLocation = new EventLocationAdding();
        _this.locationPlaceId = null;
        _this.locationPlaceCityState = null;
        _this.pageSource = 'eventful';
        _this.zoom = ConfigService.config.google.fullUSMapZoom;
        _this.isShowMarker = false;
        _this.isFeedExisted = false;
        _this.isLoadingFeeds = false;
        _this.inAddingLocationFeed = false;
        _this.isLoadingPlaceSource = false;
        _this.placeSource = 'facebook';
        _this.showSuccessInfo = false;
        _this.percentage = null;
        _this.mileToMeters = config.mileToMeters;
        _this.isLoadingSpiderEventPages = false;
        _this.spiderEventPages = [];
        _this.pagesMax = config.maxLocationFeedLimit;
        _this.toggles = new HubVisitorFeatureToggle();
        _this.isKeepTempClosedPlaceInApproved = false;
        _this.selectedGoogleCategories = [];
        _this.urlSourceItems = [
            // {
            //     text: 'Eventbrite',
            //     value: 'eventbrite'
            // },
            {
                text: 'Eventful',
                value: 'eventful',
            },
        ];
        _this.maxCroppedWidth = 800;
        _this.placeLocationFilters = [];
        _this.eventLocationFilters = [];
        return _this;
    }
    ContentManagementComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.eventPage.tags = 'Visitor Posts';
        this.pageSource = 'eventbrite';
        this.changeTooltip();
        this.cropperSettingsForPDF = new CropperSettings();
        this.PDFSettings = {
            pdf: {
                headerImage: {
                    event: { isDefault: true, url: null },
                    place: { isDefault: true, url: null },
                    tour: { isDefault: true, url: null },
                    trip: { isDefault: true, url: null },
                },
            },
            eventCalendarURL: null,
            placeCalendarURL: null,
            moreToursURL: null,
        };
        this.PDFSettingImageCorperData = {
            event: {},
            place: {},
            tour: {},
            trip: {},
        };
        this.eventFormGroup = this.formBuilder.group({
            facebookPageUrlOrName: [null, [Validators.required]],
            displayTitle: [null, null],
            tags: [null, null],
        });
        this.placeFacebookFormGroup = this.formBuilder.group({
            facebookPageUrlOrName: [null, [Validators.required]],
            displayTitle: [null, null],
            tags: [null, null],
        });
        this.locationFormGroup = this.formBuilder.group({
            address: [null, [Validators.required]],
            displayTitle: [null, null],
            filterByCity: [null, null],
            tags: [null, null],
            radius: [null, [Validators.required]],
        });
        this.hubFacebookFeedsStore.pagesCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubPages) {
            _this.hubPages = hubPages.hubPages;
        });
        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubLocations) {
            _this.hubLocations = hubLocations.hubPages;
        });
        this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            if (toggleCommand.toggle) {
                _this.toggles = toggleCommand.toggle;
                _this.eventLocation.isFilterByCity = _this.toggles.multipleCities;
                _this.locationSource = 'eventbrite';
                _this.isKeepTempClosedPlaceInApproved = toggleCommand.isKeepTempClosedPlaceInApproved;
                if (toggleCommand && toggleCommand.dataSource) {
                    var eventSources = [
                        // Eventbrite had turned the event api off
                        //     {
                        //     text: 'Eventbrite',
                        //     value: 'eventbrite',
                        //     visible: this.toggles.eventByGeolocation
                        // },
                        {
                            text: 'Performers, Venues, Ticketing Websites',
                            value: 'eventful',
                            visible: _this.toggles.eventByGeolocation,
                        },
                    ];
                    var sourceItems = [];
                    if (_this.toggles.placeCalendar) {
                        if (toggleCommand.dataSource.place === 'facebook') {
                            sourceItems = [
                                {
                                    text: 'Facebook Places',
                                    value: 'facebook',
                                    selected: true,
                                },
                            ];
                        }
                        else if (toggleCommand.dataSource.place === 'google') {
                            sourceItems = [
                                {
                                    text: 'Google Places',
                                    value: 'google',
                                    selected: true,
                                },
                            ];
                        }
                        _this.placeSource = toggleCommand.dataSource.place;
                        _this.locationSource = toggleCommand.dataSource.place;
                    }
                    // if (this.toggles.eventByGeolocation) {
                    //     sourceItems.push(...eventSources);
                    // }
                    _this.sourceItems = sourceItems;
                }
            }
        });
        if (!this.hubLocations || !this.hubLocations.length) {
            //this.loadLocationFeeds();
            this.getHubLocations();
        }
        this.loadSpiderEventPages();
        this.loadPlaceLocationFilters();
        this.loadEventLocationFilters();
        // this.isLoadingPlaceSource = true;
        // this.hubApiService.getDataSource(this.hubName).subscribe(data => {
        //     if (data) {
        //         this.placeSource = data.place;
        //     }
        //     this.isLoadingPlaceSource = false;
        // });
        this.customizationService
            .getPDFSettings(this.hubName)
            .subscribe(function (settings) {
            _this.PDFSettings.pdf.headerImage.event.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
                    settings.pdf.headerImage.event.isDefault;
            _this.PDFSettings.pdf.headerImage.event.url = _this.PDFSettings.pdf.headerImage.event
                .isDefault
                ? null
                : settings.pdf.headerImage.event.url;
            if (_this.PDFSettings.pdf.headerImage.event.url &&
                _this.PDFSettings.pdf.headerImage.event.url.length) {
                _this.PDFSettingImageCorperData.event.image =
                    _this.PDFSettings.pdf.headerImage.event.url[0];
            }
            _this.PDFSettings.pdf.headerImage.place.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
                    settings.pdf.headerImage.place.isDefault;
            _this.PDFSettings.pdf.headerImage.place.url = _this.PDFSettings.pdf.headerImage.place
                .isDefault
                ? null
                : settings.pdf.headerImage.place.url;
            if (_this.PDFSettings.pdf.headerImage.place.url &&
                _this.PDFSettings.pdf.headerImage.place.url.length) {
                _this.PDFSettingImageCorperData.place.image =
                    _this.PDFSettings.pdf.headerImage.place.url[0];
            }
            _this.PDFSettings.pdf.headerImage.tour.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
                    settings.pdf.headerImage.tour.isDefault;
            _this.PDFSettings.pdf.headerImage.tour.url = _this.PDFSettings.pdf.headerImage.tour.isDefault
                ? null
                : settings.pdf.headerImage.tour.url;
            if (_this.PDFSettings.pdf.headerImage.tour.url) {
                _this.PDFSettingImageCorperData.tour.image = _this.PDFSettings.pdf.headerImage.tour.url;
            }
            _this.PDFSettings.pdf.headerImage.trip.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
                    settings.pdf.headerImage.trip.isDefault;
            _this.PDFSettings.pdf.headerImage.trip.url = _this.PDFSettings.pdf.headerImage.trip.isDefault
                ? null
                : settings.pdf.headerImage.trip.url;
            if (_this.PDFSettings.pdf.headerImage.trip.url) {
                _this.PDFSettingImageCorperData.trip.image = _this.PDFSettings.pdf.headerImage.trip.url;
            }
            setTimeout(function () {
                _this.eventImgCropper && _this.eventImgCropper.setImageData(_this.cropperSettingsForPDF);
                _this.placeImgCropper && _this.placeImgCropper.setImageData(_this.cropperSettingsForPDF);
            });
        });
        setTimeout(function () {
            _this.parent.location = 'Events';
        });
        this.setPDFSize();
    };
    ContentManagementComponent.prototype.setPDFSize = function () {
        var rect = this.tab._elementRef.nativeElement.getBoundingClientRect(); //1228 / 2;
        // let width = (rect.width - 18 * 4 - 12) / 2;
        // width = width <= 0 ? window.innerWidth * 0.379 : width;
        var width = window.innerWidth * 0.379;
        var height = (width * 60) / 210;
        this.cropperSettingsForPDF = this.imageService.createImageCropperSetting(width, height, true);
    };
    ContentManagementComponent.prototype.loadSpiderEventPages = function () {
        var _this = this;
        this.isLoadingSpiderEventPages = true;
        this.hubApiService.getSpiderEventPages(this.hubName).subscribe(function (data) {
            _this.isLoadingSpiderEventPages = false;
            _this.spiderEventPages = data.pages
                .filter(function (x) { return x.socialName.toLowerCase().indexOf('facebook') >= 0; })
                .map(function (x) {
                return {
                    url: x.url.replace('https://facebook.com/', 'https://www.facebook.com/').trim(),
                    socialName: x.socialName,
                    tag: x.tag,
                    _id: x._id,
                };
            })
                .sort(function (a, b) {
                return a.url.toLowerCase().localeCompare(b.url.toLowerCase());
            });
            console.log(_this.spiderEventPages);
            _this.pagesMax = isNullOrUndefined(data.pagesMax)
                ? config.maxLocationFeedLimit
                : data.pagesMax;
        });
    };
    ContentManagementComponent.prototype.loadPlaceLocationFilters = function () {
        var _this = this;
        this.hubApiService.getPlaceLocationFilters(this.hubName).subscribe(function (data) {
            _this.placeLocationFilters = data;
        });
    };
    ContentManagementComponent.prototype.loadEventLocationFilters = function () {
        var _this = this;
        this.hubApiService.getEventLocationFilters(this.hubName).subscribe(function (data) {
            _this.eventLocationFilters = data;
        });
    };
    ContentManagementComponent.prototype.showLocationWidgetUrl = function (location, type) {
        var link = "<div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/" + type + "/location/" + location.locality + "\" url-change=\"true\" version=\"V3\">\n        <app-root></app-root> \n        <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n    </div>";
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Place Location Widget URL', null, [], link, true),
                },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    Object.defineProperty(ContentManagementComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.toggles.manualEvents || this.toggles.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    ContentManagementComponent.prototype.loadLocationFeeds = function () {
        var _this = this;
        if (!this.hubLocations || !this.hubLocations.length) {
            this.isLoadingFeeds = true;
            this.hubApiService.getLocationFeeds(this.hubName).subscribe(function (data) {
                _this.hubLocations = data;
                _this.isLoadingFeeds = false;
            });
        }
    };
    ContentManagementComponent.prototype.showCategoryPopup = function () {
        var _this = this;
        var actions = {
            confirm: function (data) {
                _this.selectedGoogleCategories = data;
                localStorage.setItem(localStorageKeys.googlePlaceTypeToPull, JSON.stringify(data));
            },
        };
        this.modalService.show({
            component: PullGooglePlaceTypeModalComponent,
            providers: [{ provide: PullGooglePlaceTypeModalActions, useValue: actions }],
            panelClass: 'width-modal-90p',
        });
    };
    ContentManagementComponent.prototype.savePDFEventHeaderImage = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var data, imageFile, imageBase64, res, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new PDFSettingCommand();
                        if (!this.PDFSettings.pdf.headerImage.event.isDefault) return [3 /*break*/, 1];
                        this.PDFSettingImageCorperData.event.image = '';
                        data.pdf.headerImage.event = {
                            isDefault: this.PDFSettings.pdf.headerImage.event.isDefault,
                            url: [],
                        };
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, this.imageService.compressImageFile(this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.event.image), 1400)];
                    case 2:
                        imageFile = _a.sent();
                        return [4 /*yield*/, this.imageService.getBase64ByImageFile(imageFile)];
                    case 3:
                        imageBase64 = _a.sent();
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(imageBase64, 1400)];
                    case 4:
                        res = _a.sent();
                        url = res.url;
                        data.pdf.headerImage.event = {
                            isDefault: this.PDFSettings.pdf.headerImage.event.isDefault,
                            url: [url],
                        };
                        _a.label = 5;
                    case 5:
                        // data.pdf.headerImage.place = {
                        //     isDefault: false,
                        //     url: 'not-changed'
                        // };
                        this.customizationService
                            .setPDFEventHeaderImage(this.hubName, data.pdf.headerImage.event)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Change the event pdf event header image');
                            _this.pdfSettingsStore.pdfCommand.next(data);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ContentManagementComponent.prototype.savePDFPlaceHeaderImage = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var data, imageFile, imageBase64, res, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new PDFSettingCommand();
                        if (!this.PDFSettings.pdf.headerImage.place.isDefault) return [3 /*break*/, 1];
                        this.PDFSettingImageCorperData.place.image = '';
                        data.pdf.headerImage.place = {
                            isDefault: this.PDFSettings.pdf.headerImage.place.isDefault,
                            url: [],
                        };
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, this.imageService.compressImageFile(this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.place.image), 1400)];
                    case 2:
                        imageFile = _a.sent();
                        return [4 /*yield*/, this.imageService.getBase64ByImageFile(imageFile)];
                    case 3:
                        imageBase64 = _a.sent();
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(imageBase64, 1400)];
                    case 4:
                        res = _a.sent();
                        url = res.url;
                        data.pdf.headerImage.place = {
                            isDefault: this.PDFSettings.pdf.headerImage.place.isDefault,
                            url: [url],
                        };
                        _a.label = 5;
                    case 5:
                        // data.pdf.headerImage.event = {
                        //     isDefault: false,
                        //     url: 'not-changed'
                        // };
                        this.customizationService
                            .setPDFPlaceHeaderImage(this.hubName, data.pdf.headerImage.place)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Change the place pdf event header image');
                            _this.pdfSettingsStore.pdfCommand.next(data);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ContentManagementComponent.prototype.keepTempClosedInApproved = function () {
        var _this = this;
        this.customizationService
            .setIsKeepTempClosedPlaceInApproved(this.hubName, this.isKeepTempClosedPlaceInApproved)
            .subscribe(function () {
            _this.alertify.successfully('Change temporarily closed place status');
        });
    };
    ContentManagementComponent.prototype.filterPlacesByCity = function () {
        if (!this.eventLocation.isFilterByCity) {
            this.eventLocation.filterByCity = null;
        }
        else {
            this.eventLocation.filterByCity = this.locationPlaceCityState; //this.locationPlaceId;
        }
    };
    ContentManagementComponent.prototype.bulkGeneration = function () {
        var modal = document.querySelector('.ig-bulk-ai-descriptions-modal');
        if (modal) {
            modal.classList.add('ig-shake');
            setTimeout(function () {
                modal.classList.remove('ig-shake');
            }, 1000);
            return;
        }
        this.bulkAIDescriptionsStore.bulkAIDescriptionsCommand.next(this.hubName);
        var factory = this.componentFactoryResolver.resolveComponentFactory(BulkAIDescriptionsModalComponent);
        var componentRef = factory.create(this.injector);
        var appElement = document.querySelector('body');
        var componentRootElement = componentRef.location.nativeElement;
        appElement && appElement.appendChild(componentRootElement);
    };
    ContentManagementComponent.prototype.addFBPage = function (event) {
        var _this = this;
        var fbID = this.getFBID(this.placePageFacebook.facebookPageUrlOrName);
        if (!fbID) {
            this.modalService.showErrorModal('Please enter a valid facebook page url or name!');
            event.complete();
            return;
        }
        this.hubApiService
            .addFacebookPageFeed(this.hubName, new AddFacebookGeneralFeedCommand(fbID, this.placePageFacebook.displayTitle, this.placePageFacebook.tags, this.hubName))
            .finally(event.complete)
            .subscribe(function (result) {
            var data = {
                confirmModalIcon: 'done',
                confirmModalTitle: 'Success',
                confirmModalDescription: 'Added the place of Facebook page success',
                confirmModalCancelButtonText: 'OK',
                isAsync: true,
            };
            if (result && result.error) {
                data.confirmModalTitle = 'Failed';
                data.confirmModalIcon = 'warning';
                if (result.error.code === 100) {
                    data.confirmModalDescription =
                        "Uh-oh! Check your Facebook page settings! It appears that your page has Country or Age restrictions and we won't be able to retrieve events, according to the Facebook API guidelines.";
                }
                else if (result.error.code === 803) {
                    data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
                }
                else if (result.error.code === 3333) {
                    data.confirmModalDescription =
                        '<div>Looks like this page is using a Facebook category that we do not recognize: ' +
                            decodeURIComponent(result.error.message) +
                            ' <br><br> Here is how you can still promote this business:<br>' +
                            'Contact the business to edit their categories (they can add up to three!) <br><a target="_blank" href="../../../assets/pages/recognized.categories.html">View our list of recognized categories</a><br><br>' +
                            'OR <br><br>If you feel this category should be included in your ImGoing account, please contact our <a href="mailto:support@iti-digital.zendesk.com?subject=Please Add the Place Category!&body=Please add the place category: ' +
                            result.error.message +
                            ', for the place: ' +
                            fbID +
                            '">support team</a></div>';
                    _this.getHubPageFeeds();
                }
                else if (result.error.code === 4444) {
                    data.confirmModalDescription =
                        '<div>Uh-oh! Looks like the Facebook Business Page you are trying to add is not an official Facebook page, or it has no physical address and ImGoing will need that information to display the place on the map!\n' +
                            '\n' +
                            'We recommend that you contact the business, have them update the physical address on their page, and then try re-adding it here. Contact our team at <a href="mailto:support@iti-digital-zendesk.com">support@iti-digital-zendesk.com</a> if you have any questions!</div>';
                    _this.getHubPageFeeds();
                }
                else {
                    console.log(result.error.message);
                    data.confirmModalDescription =
                        'Uh-oh! Please check if this is a correct Facebook place page. Contact our team at <a href="mailto:support@iti-digital-zendesk.com">support@iti-digital-zendesk.com</a> if you have any questions!</div>';
                }
            }
            else {
                _this.placeFacebookFormGroup.markAsPristine();
                _this.placePageFacebook.displayTitle = null;
                _this.placePageFacebook.facebookPageUrlOrName = null;
                _this.getHubPageFeeds();
            }
            var actions = {};
            _this.modalService.show({
                component: ConfirmModalComponent,
                providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: data },
                ],
            });
        });
    };
    ContentManagementComponent.prototype.tabChanged = function ($event) {
        this.parent.location = $event.tab.textLabel;
        if (!window.location.href.includes('localhost')) {
            var authToken = localStorage.getItem(localStorageKeys.authToken);
            var tokenInfo = jwt_decode(authToken);
            try {
                var trackName = 'click - ContentManagement - ' + $event.tab.textLabel;
                window['pendo'].track(trackName, {
                    accountId: tokenInfo.userName,
                    timestamp: Date.now(),
                    hubName: this.hubName,
                });
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    ContentManagementComponent.prototype.addEventPage = function () {
        var _this = this;
        if (this.checkIfExceedLimit('spider')) {
            return;
        }
        var actions = {
            confirm: function (event, url) {
                console.log(url);
                if (!_this.isFacebookEventPage(url)) {
                    _this.alertify.warning('Please enter a correct Facebook event page');
                    event.stop();
                    return;
                }
                if (_this.spiderEventPages.any(function (x) { return x.url === url; })) {
                    _this.alertify.warning('You have already added this page');
                    event.stop();
                    return;
                }
                _this.hubApiService.saveSpiderEventPages(_this.hubName, url).subscribe(function (data) {
                    _this.loadSpiderEventPages();
                    event.complete();
                });
            },
        };
        this.modalService.show({
            component: InputModalComponent,
            providers: [
                { provide: InputModalActions, useValue: actions },
                {
                    provide: InputModalData,
                    useValue: new InputModalData('Add Event Page URL', 'e.g., https://www.facebook.com/rockandrollhalloffame/events', null, 'SAVE', 'CANCEL', true),
                },
            ],
            panelClass: 'width-modal-2',
        });
    };
    ContentManagementComponent.prototype.removeEventPage = function (page) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .deleteSpiderEventPage(_this.hubName, page._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.loadSpiderEventPages();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this event page?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    ContentManagementComponent.prototype.editEventPage = function (page) {
        var _this = this;
        var actions = {
            confirm: function (event, url) {
                if (!_this.isFacebookEventPage(url)) {
                    _this.alertify.warning('Please enter a correct Facebook event page');
                    event.stop();
                    return;
                }
                if (_this.spiderEventPages.any(function (x) { return x.url === url; })) {
                    _this.alertify.warning('You have already added this page');
                    event.stop();
                    return;
                }
                _this.hubApiService.editSpiderEventPage(_this.hubName, page, url).subscribe(function (data) {
                    _this.loadSpiderEventPages();
                    event.complete();
                });
            },
        };
        this.modalService.show({
            component: InputModalComponent,
            providers: [
                { provide: InputModalActions, useValue: actions },
                {
                    provide: InputModalData,
                    useValue: new InputModalData('Edit Event Page URL', 'e.g., https://www.facebook.com/rockandrollhalloffame/events', page.url, 'SAVE', 'CANCEL', true),
                },
            ],
            panelClass: 'width-modal-2',
        });
    };
    ContentManagementComponent.prototype.addEventBriteOrEventfulPage = function (event) {
        var _this = this;
        if (this.pageSource == 'eventbrite') {
            var organizer = this.GetOrganizerInfo(this.eventPage.facebookPageUrlOrName);
            if (!organizer) {
                event.complete();
                return;
            }
            this.hubApiService
                .addEventbriteOrganizerFeed(this.hubName, new AddEventBriteGeneralFeedCommand(organizer.organizerID, this.eventPage.displayTitle ? this.eventPage.displayTitle : organizer.name, this.eventPage.tags, this.hubName))
                .finally(event.complete)
                .subscribe(function (result) {
                var data = {
                    confirmModalIcon: 'done',
                    confirmModalTitle: 'Success',
                    confirmModalDescription: 'Added the events of Eventbrite organizer success',
                    confirmModalCancelButtonText: 'OK',
                    isAsync: true,
                };
                if (result && result.error) {
                    data.confirmModalTitle = 'Failed';
                    data.confirmModalIcon = 'warning';
                    if (result.error.code === 100) {
                        data.confirmModalDescription = 'Uh-oh! Check your Eventbrite organizer settings! ';
                    }
                    else if (result.error.code === 803) {
                        data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
                    }
                }
                else {
                    _this.eventFormGroup.markAsPristine();
                    _this.eventPage.displayTitle = null;
                    _this.eventPage.facebookPageUrlOrName = null;
                    _this.getHubPageFeeds();
                }
                var actions = {};
                _this.modalService.show({
                    component: ConfirmModalComponent,
                    providers: [
                        { provide: ConfirmModalActions, useValue: actions },
                        { provide: ConfirmModalData, useValue: data },
                    ],
                });
            });
        }
        else if (this.pageSource == 'eventful') {
            var venue = this.GetVenueInfo(this.eventPage.facebookPageUrlOrName);
            if (!venue) {
                event.complete();
                return;
            }
            this.hubApiService
                .addEventfulVenueFeed(this.hubName, new AddEventBriteGeneralFeedCommand(venue.venueID, this.eventPage.displayTitle ? this.eventPage.displayTitle : venue.name, this.eventPage.tags, this.hubName))
                .finally(event.complete)
                .subscribe(function (result) {
                var data = {
                    confirmModalIcon: 'done',
                    confirmModalTitle: 'Success',
                    confirmModalDescription: 'Added the events of Eventful venue success',
                    confirmModalCancelButtonText: 'OK',
                    isAsync: true,
                };
                if (result && result.error) {
                    data.confirmModalTitle = 'Failed';
                    data.confirmModalIcon = 'warning';
                    if (result.error.code === 100) {
                        data.confirmModalDescription = 'Uh-oh! Check your eventful venue settings! ';
                    }
                    else if (result.error.code === 803) {
                        data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
                    }
                }
                else {
                    _this.eventFormGroup.markAsPristine();
                    _this.eventPage.displayTitle = null;
                    _this.eventPage.facebookPageUrlOrName = null;
                    _this.getHubPageFeeds();
                }
                var actions = {};
                _this.modalService.show({
                    component: ConfirmModalComponent,
                    providers: [
                        { provide: ConfirmModalActions, useValue: actions },
                        { provide: ConfirmModalData, useValue: data },
                    ],
                });
            });
        }
    };
    ContentManagementComponent.prototype.changeTooltip = function () {
        if (this.pageSource === constantTooltip.facebookString) {
            this.pageTooltip = constantTooltip.facebookTooltip;
        }
        else if (this.pageSource === constantTooltip.eventbriteString) {
            this.pageTooltip = constantTooltip.eventbriteTooltip;
        }
        else if (this.pageSource === constantTooltip.eventfulString) {
            this.pageTooltip = constantTooltip.eventfulTooltip;
        }
    };
    ContentManagementComponent.prototype.locationStatus = function () {
        this.showSuccessInfo = false;
        this.getLocationStatus();
    };
    ContentManagementComponent.prototype.GetOrganizerInfo = function (url) {
        if (!url) {
            return null;
        }
        try {
            if (url.startsWith('https://www.eventbrite.com/o/')) {
                var organizer = url.split('?')[0].split('.com/o/')[1].split('/')[0].split('-');
                if (organizer.length > 1) {
                    var id = organizer.splice(organizer.length - 1, 1);
                    return {
                        organizerID: id[0],
                        name: organizer.join(' '),
                    };
                }
            }
            this.modalService.showErrorModal('Please enter a valid eventbrite organizer url!');
            return null;
        }
        catch (ex) {
            this.modalService.showErrorModal('Please enter a valid eventbrite organizer url!');
            return null;
        }
    };
    ContentManagementComponent.prototype.GetVenueInfo = function (url) {
        if (!url) {
            return null;
        }
        try {
            if (url.indexOf('eventful.com/') > 0) {
                var temp = url.split('/venues/')[1].split('/');
                if (temp.length == 2) {
                    return {
                        venueID: temp[1],
                        name: temp[0].split('-').join(' '),
                    };
                }
            }
            this.modalService.showErrorModal('Please enter a valid eventful venue url!');
            return null;
        }
        catch (ex) {
            this.modalService.showErrorModal('Please enter a valid eventful venue url!');
            return null;
        }
    };
    ContentManagementComponent.prototype.pageSourceChange = function (target) {
        this.pageSource = target.value;
        this.changeTooltip();
    };
    ContentManagementComponent.prototype.findOnMapBySource = function (target) {
        this.locationSource = target.value;
        this.findOnMap();
    };
    ContentManagementComponent.prototype.findOnMap = function () {
        if (this.autoCompletedAddress) {
            this.showSuccessInfo = false;
            this.eventLocation.lat = this.autoCompletedAddress.lat;
            this.eventLocation.lng = this.autoCompletedAddress.lng;
            // this.eventLocation.filterByCity = this.eventLocation.isFilterByCity ? this.locationSource === 'eventful' ? this.autoCompletedAddress.cityName : this.autoCompletedAddress.placeId : '';
            this.eventLocation.stateAbbr = this.autoCompletedAddress.stateAbbr;
            this.locationPlaceId =
                this.locationSource === 'eventful'
                    ? this.autoCompletedAddress.cityName
                    : this.autoCompletedAddress.placeId;
            this.locationPlaceCityState = this.autoCompletedAddress.cityName + ", " + this.autoCompletedAddress.stateAbbr + ", " + this.autoCompletedAddress.country;
            this.eventLocation.filterByCity = this.eventLocation.isFilterByCity
                ? this.locationPlaceCityState
                : null;
            this.zoom = ConfigService.config.google.locationMapZoom;
            this.isShowMarker = true;
            this.getLocationStatus();
        }
        else {
            this.resetMap();
        }
    };
    ContentManagementComponent.prototype.setPlaceSource = function () {
        var _this = this;
        // this is a function for the convenience of changing place source from client dashboard, so this google key is fixed (this feature will be removed later)
        this.hubApiService
            .setPlaceSource(this.hubName, this.placeSource, 'AIzaSyBTK-7XADsofCdPvDWP4Rh2QzSK6t-POaw')
            .subscribe(function () {
            _this.alertify.successfully('Change place source');
        });
    };
    ContentManagementComponent.prototype.addLocation = function (event) {
        var _this = this;
        if (this.checkIfExceedLimit('location')) {
            event.complete();
            return;
        }
        this.inAddingLocationFeed = true;
        this.showSuccessInfo = false;
        if (this.isFeedExisted) {
            this.hubApiService
                .removeLocationFeed(this.hubName, this.eventLocation.feedId, this.locationSource)
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
                setTimeout(function () {
                    _this.showSuccessInfo = false;
                    _this.infoWindow.close();
                    _this.addressInput.clear();
                    _this.getHubLocations();
                }, 1500);
            });
            return;
        }
        if (this.locationSource == 'facebook') {
            // let points = GeoService.getPoints(this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius);
            // console.log(points);
            this.hubApiService
                .addFacebookLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle
                ? this.eventLocation.displayTitle
                : this.autoCompletedAddress.address, this.hubName, this.eventLocation.filterByCity, [], //points,
            this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.stateAbbr, this.eventLocation.tags))
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
                _this.eventLocation.filterByCity = null;
                _this.getHubLocations();
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
            });
        }
        else if (this.locationSource === 'google') {
            GeoService.reset();
            var points = GeoService.getPoints(this.eventLocation.lat, this.eventLocation.lng, (this.eventLocation.radius * this.mileToMeters) / 1000);
            console.log("points.length: " + points.length);
            console.log("this.eventLocation.filterByCity: " + this.eventLocation.filterByCity);
            this.hubApiService
                .addGoogleLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle
                ? this.eventLocation.displayTitle
                : this.autoCompletedAddress.address, this.hubName, this.eventLocation.filterByCity, points, this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.stateAbbr, this.eventLocation.tags, 'google', this.selectedGoogleCategories.map(function (y) { return y.value; })))
                .finally(function () {
                event.complete();
                _this.eventLocation.filterByCity = null;
                _this.getHubLocations();
            })
                .subscribe(function (data) {
                if (data) {
                    if (data.status === 'under pulling') {
                        _this.alertify.warning(data.msg);
                        _this.inAddingLocationFeed = false;
                    }
                    else if (data.status === 'pulling') {
                        var getPullingStatus_1 = setInterval(function () {
                            _this.hubApiService.checkPullingGooglePlaceStatus(_this.hubName).subscribe(function (data) {
                                if (data && !data.isPulling) {
                                    clearInterval(getPullingStatus_1);
                                    _this.inAddingLocationFeed = false;
                                    _this.locationFormGroup.markAsPristine();
                                    _this.showSuccessInfo = true;
                                    _this.percentage = null;
                                }
                                else {
                                    _this.percentage = data.progress;
                                }
                            });
                        }, 10000);
                    }
                }
                event.complete();
            });
        }
        else if (this.locationSource == 'eventbrite') {
            this.hubApiService
                .addEventBriteLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle
                ? this.eventLocation.displayTitle
                : this.autoCompletedAddress.address, this.hubName, null, null, this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.tags, config.eventbrite))
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
                _this.getHubLocations();
            });
        }
        else if (this.locationSource == 'eventful') {
            this.hubApiService
                .addEventfulLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle
                ? this.eventLocation.displayTitle
                : this.autoCompletedAddress.address, this.hubName, this.eventLocation.filterByCity, null, this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.stateAbbr, this.eventLocation.tags, 'eventful'))
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
                _this.getHubLocations();
            });
        }
    };
    ContentManagementComponent.prototype.checkIfExceedLimit = function (type) {
        var isExceedLimit = false;
        if (type === 'location') {
            if (this.hubLocations && this.hubLocations.length) {
                // adding place location feed
                if (this.locationSource === 'facebook' || this.locationSource === 'google') {
                    if (this.hubLocations.filter(function (x) { return x.socialName === 'facebook' || x.socialName === 'google'; }).length >= config.maxLocationFeedLimit) {
                        isExceedLimit = true;
                    }
                }
                else {
                    // adding event location feed
                    if (this.hubLocations.filter(function (x) { return x.socialName === 'eventbrite' || x.socialName === 'eventful'; }).length >= config.maxLocationFeedLimit) {
                        isExceedLimit = true;
                    }
                }
            }
        }
        else if (type === 'spider') {
            if (this.pagesMax === 0) {
                isExceedLimit = false;
            }
            else if (this.spiderEventPages &&
                this.spiderEventPages.filter(function (x) { return ['facebook'].indexOf(x.socialName) >= 0; }).length >=
                    this.pagesMax) {
                isExceedLimit = true;
            }
        }
        if (isExceedLimit) {
            var data = {
                confirmModalIcon: 'warning',
                confirmModalTitle: 'Warning',
                confirmModalDescription: "The number of " + (type === 'location' ? 'locations' : 'event pages') + " you have added has exceeded the limit, please contact our team, emailing <a href=\"mailto:aline@iti-digital.com\">aline@iti-digital.com</a> or call us at 912-267-1558</p>",
                confirmModalCancelButtonText: 'OK',
                isAsync: true,
            };
            var actions = {};
            this.modalService.show({
                component: ConfirmModalComponent,
                providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: data },
                ],
            });
            return true;
        }
        return false;
    };
    ContentManagementComponent.prototype.getHubPageFeeds = function () {
        var _this = this;
        var times = 0;
        var getFeeds = function () {
            return _this.hubApiService
                .getPageFeeds(_this.hubName)
                .catch(function (err) {
                if (times < 3) {
                    getFeeds();
                }
                times++;
                return Observable.throw(err.statusText);
            })
                .subscribe(function (data) {
                _this.hubPages = data;
                var pageCommand = new HubFacebookFeedsCommand(data);
                _this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
            });
        };
        getFeeds();
    };
    ContentManagementComponent.prototype.getHubLocations = function () {
        var _this = this;
        var times = 0;
        this.isLoadingFeeds = true;
        var getFeeds = function () {
            return _this.hubApiService
                .getLocationFeeds(_this.hubName)
                .catch(function (err) {
                if (times < 3) {
                    getFeeds();
                }
                times++;
                return Observable.throw(err.statusText);
            })
                .subscribe(function (data) {
                _this.isLoadingFeeds = false;
                _this.hubLocations = data;
                _this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(_this.hubLocations));
            });
        };
        getFeeds();
    };
    ContentManagementComponent.prototype.getLocationStatus = function () {
        var _this = this;
        this.hubApiService
            .getLocationStatus(this.hubName, this.autoCompletedAddress.lat, this.autoCompletedAddress.lng, this.locationSource)
            .subscribe(function (result) {
            if (result) {
                _this.isFeedExisted = result.connected;
                if (_this.isFeedExisted) {
                    _this.eventLocation.displayTitle = result.title;
                }
                else {
                    _this.eventLocation.displayTitle = _this.autoCompletedAddress.address;
                }
                if (result.radius) {
                    _this.eventLocation.radius = result.radius / config.mileToMeters;
                }
                _this.eventLocation.feedId = result.feedId;
            }
        });
    };
    ContentManagementComponent.prototype.resetMap = function () {
        this.eventLocation.lat = ConfigService.config.google.USCenter.lat;
        this.eventLocation.lng = ConfigService.config.google.USCenter.lng;
        this.eventLocation.filterByCity = null;
        this.isShowMarker = false;
        this.zoom = ConfigService.config.google.fullUSMapZoom;
    };
    ContentManagementComponent.prototype.getFBID = function (link) {
        if (link.startsWith('@')) {
            return link;
        }
        if (!link || link.indexOf('https://www.facebook.com/') === -1) {
            return null;
        }
        var fbSeg = link.split('https://www.facebook.com/')[1];
        var id = null;
        var seg = fbSeg.split('/');
        if (seg[0] === 'pages') {
            id = seg[seg.length - 1];
            if (id.indexOf('-') >= 0) {
                var dashSeg = id.split('-');
                id = dashSeg[dashSeg.length - 1];
            }
        }
        else if (seg[0].indexOf('-') >= 0) {
            var dashSeg = seg[0].split('-');
            id = dashSeg[dashSeg.length - 1];
        }
        else {
            id = seg[0];
        }
        return id;
    };
    ContentManagementComponent.prototype.deleteLocationFeed = function (location) {
        var _this = this;
        var actions = {
            confirm: function (feed) {
                _this.hubApiService
                    .removeLocationFeed(_this.hubName, location.id, location.socialName)
                    .finally(feed.complete)
                    .subscribe(function () {
                    _this.getHubLocations();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this Location?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    ContentManagementComponent.prototype.deleteEventFeed = function (page) {
        var _this = this;
        var actions = {
            confirm: function (feed) {
                _this.hubApiService
                    .removePageFeed(_this.hubName, page.id)
                    .finally(feed.complete)
                    .subscribe(function () {
                    _this.getHubPageFeeds();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this page?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    ContentManagementComponent.prototype.isFacebookEventPage = function (url) {
        if (!url)
            return false;
        if (url.indexOf('facebook.com') < 0)
            return false;
        if (url.indexOf('/events') < 0)
            return false;
        return true;
    };
    return ContentManagementComponent;
}(BaseComponent));
export { ContentManagementComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/content.management/content.management.component.ts.pre-build-optimizer.js